import { apicall } from "../../services/api";
import {
	ALL_CAMPAIGN,
	ALL_ASSIGNED_CAMPAIGNS,
	ERR_CAMPAIGN,
	UPDATE_ASSIGN_CAMPAIGN,
} from "./actionTypes";
import { setAlert } from "./alert.actions";
import { Toastify } from "../../services/toastify/toastifyContainer";

export const getUnassignedCampaigns = () => async (dispatch) => {
	try {
		const response = await fetch(
			`${process.env.REACT_APP_BASE_URL_VMS}campaigns/all/`
		);
		const res = await response.json();
		dispatch({
			type: ALL_CAMPAIGN,
			payload: res,
		});
	} catch (err) {
		dispatch({
			type: ERR_CAMPAIGN,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert("Unable to fetch data", "error"));
	}
};

export const getAllAssociations = () => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/campaign_assign/`, "get");
		dispatch({
			type: ALL_ASSIGNED_CAMPAIGNS,
			payload: res.data,
		});
		
	} catch (err) {
		dispatch({
			type: ERR_CAMPAIGN,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert(err.response.data.msg, "error"));
	}
};

export const createAssociation = (data) => async (dispatch) => {
	try {
		const res = await apicall("api/v1/campaign_assign/", "post", data);


		dispatch(setAlert(res.data.message, "success"));
		dispatch(getAllAssociations());
	} catch (err) {
		dispatch({
			type: ERR_CAMPAIGN,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert(err.response.data.msg, "error"));
		Toastify({ data: "error", msg: "Please Fill All the fields.." })
	}
};

export const updateAssociation = (clientData,userId) => async (dispatch) => {
    try {
        const res = await apicall(`api/v1/campaign_assign/updateClient/${userId}`, "patch", clientData, {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
        });
		
        dispatch({
            type: UPDATE_ASSIGN_CAMPAIGN,
            payload: res.data,
        });

		if(res?.status === 201){
			Toastify({ data: "success", msg: res.data.message })
		}else{
			Toastify({ data: "success", msg: res.data.message })
		}
		return res?.data
    } catch (err) {
		if(err?.response?.data?.error === "Bad Request"){
			Toastify({ data: "error", msg: "Please Fill All the fields.." })
		}
        dispatch({
            type: ERR_CAMPAIGN,
            payload: { msg: err.message },
        });
    }
};


// export const deleteAssociation = (clientId) => async (dispatch) => {
// 	if (window.confirm("Are you sure? This can NOT be undone!")) {
// 		try {
// 			const res = await apicall(`clients/${clientId}`, "delete");
// 			dispatch({ type: REMOVE_ASSIGN_CAMPAIGN, payload: clientId });
// 			// dispatch({
// 			// 	type: ERR_CLIENTS,
// 			// 	payload: { msg: `Brand deleted successfully!`, status: res.status },
// 			// });
// 		} catch (err) {
// 			dispatch({
// 				type: ERR_CAMPAIGN,
// 				payload: { msg: err.response.msg, status: err.response.status },
// 			});
// 		}
// 	}
// };
